import QRCode from "qrcode";

export const QR_BASE_URL = "https://altindafirsat.com/product/";

export async function makeQrDataUrl(serialNumber, opts = {}) {
  if (!serialNumber) return null;
  try {
    return await QRCode.toDataURL(
      QR_BASE_URL + encodeURIComponent(serialNumber),
      Object.assign({ width: 140, margin: 1 }, opts)
    );
  } catch (e) {
    return null;
  }
}

export const certMixin = {
  props: {
    item: { type: Object, required: true, default: () => ({}) },
  },
  data: () => ({ qrDataUrl: null }),
  watch: {
    "item.serialNumber": {
      handler() {
        this.regenerateQr();
      },
      immediate: true,
    },
  },
  computed: {
    serial() {
      return this.item && this.item.serialNumber ? this.item.serialNumber : "";
    },
  },
  methods: {
    async regenerateQr() {
      this.qrDataUrl = await makeQrDataUrl(this.serial);
    },
  },
};

// Tek sertifika tipi var: Hazır Kağıt (classic). Şablon seçici kaldırıldı.
